import { Component, Inject, Input, OnInit, ViewEncapsulation } from "@angular/core";

import { PosMovementsService } from "src/app/shared/services/pos-movements/posMovements.service";
import { BehaviorSubject, EMPTY, Observable } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";
import { SnackbarService } from "src/app/shared/services/snackbar/snackbar.service";
import { TranslateService } from "@ngx-translate/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FilterEvent, FilterName } from "src/app/models/custom-table/custom-table.model";
import { setAdvancedFilter } from "src/app/shared/utils/tableUtils";

@Component({
  selector: "app-receipt-dialog",
  templateUrl: "./receipt-dialog.component.html",
  styleUrls: ["./receipt-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ReceiptDialogComponent implements OnInit {
  //Movement
  isLoading$ = new BehaviorSubject<boolean>(false);
  loadedDocument$: Observable<any>;

  receiptData: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ReceiptDialogComponent>,
    private posMovementsService: PosMovementsService,
    private snackbarService: SnackbarService,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.loadDocumentInfo();
  }

  loadDocumentInfo() {
    const advancedFilter = this.setAdvancedFilter(null);

    this.isLoading$.next(true);
    this.posMovementsService
    .getDocuments(
      undefined,
      undefined,
      undefined,
      advancedFilter,
    )
      .pipe(
        catchError((error) => {
          this.snackbarService.show({
            message: this.translate.instant("PosMovements.documentLoadError"),
            type: SnackbarType.ERROR,
          });
          return EMPTY;
        }),
        finalize(() => this.isLoading$.next(false))
      )
      .subscribe((document) => {
        const [ documentFound ] = document.items;
        const { receipt: { receiptData }} = documentFound;

        this.receiptData = receiptData.replace(/\\\\r/g, '\r').replace(/\\\\n/g, '\n');
      });
  }

  setAdvancedFilter(filterEvent: FilterEvent) {
    const documentTokenFilter = {
      column: "token",
      operator: FilterName.EQUALS_TO,
      value: this.data.documentToken,
    };

    return setAdvancedFilter(documentTokenFilter, filterEvent);
  }
}
